import { Fragment } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Divider, Typography, useTheme } from '@mui/material'

import { ReviewedCount } from './reviewed-count.component'
import { ETranslationNs, INavBarData } from 'src/types'

import useStyles from './styles'
import { ROUTES } from 'src/constants'

interface INavbarDesktopProps {
  link: INavBarData
  isSkip: boolean
  pathname: string[]
  isScanHistory: boolean
  isOpen?: boolean
  disabled: boolean
}

const NavbarMobileItem = ({
  link,
  isSkip,
  pathname,
  isScanHistory,
  isOpen = true,
  disabled,
}: INavbarDesktopProps) => {
  const [t] = useTranslation(ETranslationNs.Navbar)

  const { accountId } = useParams()

  const location = useLocation()

  const theme = useTheme()
  const classes = useStyles({ isOpen, iconMode: link?.iconMode })

  return (
    <Fragment key={link.title}>
      <Link
        style={{
          display: isSkip ? 'none' : 'flex',
          pointerEvents: disabled ? 'none' : 'auto',
          opacity: disabled ? 0.5 : 1,
        }}
        className={classes.link}
        key={link.title}
        // to={link.disabled ? location.pathname : link.path || location.pathname}
        to={
          disabled
            ? location.pathname
            : link.path.startsWith('/')
              ? isScanHistory && accountId
                ? link.path + `?accountsIds=${accountId}`
                : link.path
              : accountId && location.pathname.includes(ROUTES.ACCOUNTS)
                ? `/${ROUTES.ACCOUNTS}/${accountId}/${link.path}`
                : link.path || location.pathname
        }
        onClick={() => {
          if (!disabled && link?.onClick) {
            link.onClick()
          }
        }}
      >
        <Box width={25}>{link.icon({ isActive: link.path && pathname.includes(link.path) })}</Box>
        <div
          className={`${classes.titleWrapper} ${
            ((link.path && pathname.includes(link.path)) || link.isActive) && classes.activeColor
          }`}
          style={{ position: 'relative' }}
        >
          {t(link.title)}

          <>{isScanHistory && <ReviewedCount />}</>
          {link.path === `/${ROUTES.USER}/${ROUTES.SCAN_TO_EARN}` && (
            <Typography
              sx={{
                position: 'absolute',
                top: '0px',
                right: '-32px',
                fontStyle: 'italic',
                fontSize: '9px',
                fontWeight: 700,
                color: theme.palette.custom.primary,
              }}
            >
              ALPHA
            </Typography>
          )}
        </div>
      </Link>
      {link.withDivider && !isSkip && <Divider variant="fullWidth" flexItem />}
    </Fragment>
  )
}

export { NavbarMobileItem }
